import { UserAuthState, initialAuthState } from './slices/auth/initial-state';
import { CommonState, initialCommonState } from './slices/common/initial-state';
import { UserPreferenceState, initialPreferenceState } from './slices/preference/initial-state';
import { UserSettingsState, initialSettingsState } from './slices/settings/initial-state';

export type UserState =
  UserSettingsState &
  UserPreferenceState &
  UserAuthState &
  CommonState;

export const initialState: UserState = {
  ...initialSettingsState,
  ...initialPreferenceState,
  ...initialAuthState,
  ...initialCommonState,
};
